// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"998bdbad","703":"c438e8dd","787":"8dd69bcb"}[chunkId] + ".chunk.js";
};